export const AUTH_ACTIONS = {
    REDIRECT: 'REDIRECT',
    JOIN_STUDY: 'JOIN_STUDY',
};
